<template>
	<div
		@click="closeint()"
		class="app"
		v-bind:class="{
			'app-header-fixed': appOptions.appHeaderFixed && !appOptions.appHeaderNone && !appOptions.appEmpty,
			'app-sidebar-fixed': appOptions.appSidebarFixed,
			'app-sidebar-minified': appOptions.appSidebarMinified,
			'app-content-full-height': appOptions.appContentFullHeight,
			'app-without-sidebar': appOptions.appSidebarNone,
			'app-with-end-sidebar': appOptions.appSidebarEnd,
			'app-with-two-sidebar': appOptions.appSidebarTwo,
			'app-with-wide-sidebar': appOptions.appSidebarWide,
			'app-with-light-sidebar': appOptions.appSidebarLight,
			'app-sidebar-mobile-toggled': appOptions.appSidebarMobileToggled,
			'app-sidebar-end-toggled': appOptions.appSidebarEndToggled,
			'app-sidebar-end-collapsed': !appOptions.appSidebarEndToggled,
			'app-sidebar-end-mobile-toggled': appOptions.appSidebarEndMobileToggled,
			'app-without-header': appOptions.appHeaderNone,
			'app-with-top-menu': appOptions.appTopMenu,
			'app-gradient-enabled': appOptions.appGradientEnabled,
			'has-scroll': appOptions.appBodyScrollTop,
			ishfives: allhfives
		}"
	>
		<Header v-if="appOptions && !appOptions.appEmpty" />
		<Sidebar v-if="!appOptions.appSidebarNone && appOptions && !appOptions.appEmpty" />
		<div v-if="appOptions" id="content" :class="{ 'app-content': appOptions && !appOptions.appEmpty }" v-bind:class="appOptions.appContentClass">
			<router-view></router-view>
			<vue-ins-progress-bar></vue-ins-progress-bar>
		</div>
		<ScrollTopBtn v-if="appOptions && !appOptions.appEmpty" />
	</div>
	<!-- <div class="iswidth h-100" v-if="appOptions && appOptions.appEmpty">
		<router-view></router-view>
		<vue-ins-progress-bar></vue-ins-progress-bar>
	</div> -->
</template>

<style lang="scss">
@import url('./assets/allcss/base.css');

// .tox-tinymce-aux {
// 	z-index: 50000 !important;
// }
// .iswidth {
// 	max-width: 1920px;
// 	margin: 0 auto;
// }

/* 防止打开对话框时页面的抖动 */
body {
	padding-right: 0px !important;
	// overflow: hidden;
}

// @import url("./assets/helang-flex.scss");
.app-sidebar {
	padding-top: 62px;
}

.app-sidebar {
	background-color: #fff !important;
}

.app {
	width: 100%;
	height: auto;
	// overflow-x: hidden;
}

.ishfives {
	overflow: hidden;
	background-color: red !important;
}

.iswidth {
	// width: 1920px;
	background: #eff2fa !important;
	margin: 0 auto;
	// position: absolute;
	// top: 50%;
	// left: 50%;
	// transform: translate(-50%, -50%);
	// transform-origin: left top;
}

body {
	background: #eff2fa !important;
}

body::-webkit-scrollbar {
	display: none;
	-ms-overflow-style: none;
	scrollbar-width: none;
}
</style>

<script>
import Sidebar from './components/sidebar/Sidebar.vue';

import Header from './components/header/Header.vue';

import ScrollTopBtn from './components/scroll-top-btn/ScrollTopBtn.vue';
import AppOptions from './config/AppOptions.vue';

import { GetUserSentPaper, GetDate } from '@/request/api/homesview/yunhomes/yunhom';
import useDraw from '@/utils/useDraw';
export default {
	name: 'app',
	components: {
		Sidebar,
		Header,
		ScrollTopBtn
	},
	data() {
		return {
			appOptions: AppOptions,
			screenWidth: document.body.clientWidth,
			// 判断h5或者pc
			allhfives: false,
			timers: '',
			isallpages: true,
			appRef: '',
			calcRate: '',
			windowDraw: '',
			unWindowDraw: ''
		};
	},
	beforeCreate() {
		this.appOptions = AppOptions;
		if (localStorage.getItem('uiguid')) {
			// console.log("执行token有的情况111")
			GetDate().then(res => {
				this.timers = res.data.data;
			});
		}
	},
	beforeMount() {
		// console.log(this.appOptions.appEmpty,'是否是这里挂载执行了两次')
	},
	deactivated() {
		// this.unWindowDraw();
	},

	methods: {
		validate(str) {
			let a = /^[0-9]{6,16}$|^[a-zA-Z]{6,16}$/;
			// var reg = new RegExp();
			if (str.match(a)) {
				return true;
			} else {
				return false;
			}
		},
		closeint() {
			this.$nextTick(() => {
				this.$children[0].allshow = false;
			});
			let downsnumne = document.querySelector('#downsnumne');

			// console.log('你点击了屏幕', downsnumne.style.display);
			// console.log(document.querySelector(".fontipt"))
			let dinputs = document.querySelector('.fontipt');
			if (dinputs) {
				downsnumne.style.display = 'none';
				dinputs.placeholder = '搜索...';
				dinputs.style.background = 'rgba(255, 255, 255, 0.2)';
				dinputs.style.color = '#000';
			}
		},

		handleScroll: function() {
			AppOptions.appBodyScrollTop = window.scrollY;
		},
		handleSetColor: function() {
			AppOptions.color = {
				componentColor: window
					.getComputedStyle(document.body)
					.getPropertyValue('--app-component-color')
					.trim(),
				componentBg: window
					.getComputedStyle(document.body)
					.getPropertyValue('--app-component-bg')
					.trim(),
				dark: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-dark')
					.trim(),
				light: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-light')
					.trim(),
				blue: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-blue')
					.trim(),
				indigo: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-indigo')
					.trim(),
				purple: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-purple')
					.trim(),
				pink: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-pink')
					.trim(),
				red: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-red')
					.trim(),
				orange: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-orange')
					.trim(),
				yellow: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-yellow')
					.trim(),
				green: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-green')
					.trim(),
				success: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-success')
					.trim(),
				teal: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-teal')
					.trim(),
				cyan: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-cyan')
					.trim(),
				white: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-white')
					.trim(),
				gray: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray')
					.trim(),
				lime: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-lime')
					.trim(),
				gray100: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-100')
					.trim(),
				gray200: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-200')
					.trim(),
				gray300: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-300')
					.trim(),
				gray400: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-400')
					.trim(),
				gray500: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-500')
					.trim(),
				gray600: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-600')
					.trim(),
				gray700: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-700')
					.trim(),
				gray800: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-800')
					.trim(),
				gray900: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-900')
					.trim(),
				black: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-black')
					.trim(),
				componentColorRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--app-component-color-rgb')
					.trim(),
				componentBgRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--app-component-bg-rgb')
					.trim(),
				darkRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-dark-rgb')
					.trim(),
				lightRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-light-rgb')
					.trim(),
				blueRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-blue-rgb')
					.trim(),
				indigoRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-indigo-rgb')
					.trim(),
				purpleRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-purple-rgb')
					.trim(),
				pinkRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-pink-rgb')
					.trim(),
				redRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-red-rgb')
					.trim(),
				orangeRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-orange-rgb')
					.trim(),
				yellowRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-yellow-rgb')
					.trim(),
				greenRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-green-rgb')
					.trim(),
				successRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-success-rgb')
					.trim(),
				tealRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-teal-rgb')
					.trim(),
				cyanRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-cyan-rgb')
					.trim(),
				whiteRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-white-rgb')
					.trim(),
				grayRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-rgb')
					.trim(),
				limeRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-lime-rgb')
					.trim(),
				gray100Rgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-100-rgb')
					.trim(),
				gray200Rgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-200-rgb')
					.trim(),
				gray300Rgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-300-rgb')
					.trim(),
				gray400Rgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-400-rgb')
					.trim(),
				gray500Rgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-500-rgb')
					.trim(),
				gray600Rgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-600-rgb')
					.trim(),
				gray700Rgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-700-rgb')
					.trim(),
				gray800Rgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-800-rgb')
					.trim(),
				gray900Rgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-gray-900-rgb')
					.trim(),
				blackRgb: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-black-rgb')
					.trim()
			};
		},
		handleSetFont: function() {
			AppOptions.font = {
				family: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-body-font-family')
					.trim(),
				size: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-body-font-size')
					.trim(),
				weight: window
					.getComputedStyle(document.body)
					.getPropertyValue('--bs-body-font-family')
					.trim()
			};
		},
		handleSetDarkMode: function(value) {
			if (value === true) {
				document.body.classList.add('dark-mode');
			} else {
				document.body.classList.remove('dark-mode');
			}
			this.handleSetColor();
		},
		handleSetTheme: function(value) {
			var newTheme = 'theme-' + value;
			for (var x = 0; x < document.body.classList.length; x++) {
				if (document.body.classList[x].indexOf('theme-') > -1 && document.body.classList[x] !== newTheme) {
					document.body.classList.remove(document.body.classList[x]);
				}
			}
			document.body.classList.add(newTheme);
		},
		handleChangeTheme: function() {
			this.handleSetTheme(AppOptions.appTheme);
			this.handleSetDarkMode(AppOptions.appDarkMode);
		}
	},
	updated() {
		// if (this.appOptions && AppOptions) {
		// 	if (this.$route.meta.isallmain) {
		// 		this.appOptions.appEmpty = true;
		// 	} else {
		// 		this.appOptions.appEmpty = false;
		// 	}
		// }
		// console.log(this.appOptions.appEmpty, this.$route.meta, '获取');
	},
	mounted() {
		this.$insProgress.finish();

		// console.log(this.$route,'对应得标签')
		// 下面不是
		const that = this;
		window.onresize = () => {
			return (() => {
				window.screenWidth = document.body.clientWidth;
				that.screenWidth = window.screenWidth;
				// console.log(that.screenWidth)
				that.$store.commit('scoolswidth', that.screenWidth);
				// console.log(that.$store)
			})();
		};

		// 如果这个人有考试就不断提示，当进行考试页面不会提示离开考试
		if (this.$cookie.get('Token') || localStorage.getItem('uiguid')) {
			if (this.$route) {
				if (this.$route.path != '/pageme/examine') {
					let exmineksobj = {
						UI_GUID: localStorage.getItem('uiguid'),
						SSP_Status: 0,
						pageIndex: 1,
						pageSize: 40,
						SSP_EndTime: '',
						SSP_StartTime: '',
						SPA_PaperTitle: '',
						SPA_TYPE: '',
						SSP_Status: ''
					};
					GetUserSentPaper(exmineksobj).then(res => {
						// console.log(res.data.code, '考试');
						// 创建两个日期对象
						if (res.data.code > 0) {
							if (res.data.data.list.length > 0) {
								let date1 = new Date(this.timers);
								// console.log('我在这里1')
								res.data.data.list.forEach(item => {
									// console.log(item.ExamStatus == 2,item.SSP_Status == 0,'是否为true')
									if (item.ExamStatus == 2 && item.SSP_Status == 0) {
										this.$confirm('检测到您当前有考试，请问是否前往？', '提示', {
											confirmButtonText: '开始考试',
											cancelButtonText: '暂时不考',
											type: 'warning'
										})
											.then(() => {
												this.$router.push('/usercenter/homesview/testists/Myexamind');
											})
											.catch(() => {});
									}
								});
							}
						} else {
							this.$router.push('/user/logins');
						}
					});
					// .catch(err => {
					// 	// console.log(err, '错误');
					// 	let errstr = JSON.stringify(error.response)
					// 	this.$router.push('/user/logins');
					// 	window.sessionStorage.setItem('errstr',errstr)
					// 	location.reload()
					// });
				}
			}
		}

		// console.log("找搜索", this.$children[0].allshow)
	},
	destroyed() {
		window.localStorage.clear();
	},
	created() {
		AppOptions.appBodyScrollTop = window.scrollY;

		window.addEventListener('scroll', this.handleScroll);

		this.$insProgress.start();
		this.handleSetColor();
		this.handleSetFont();

		if (AppOptions.appDarkMode) {
			this.handleSetDarkMode(true);
		}
		if (AppOptions.appTheme) {
			this.handleSetTheme(AppOptions.appTheme);
		}

		this.$router.afterEach((to, from, next) => {
			// console.log(to.path);
			if (this.$cookie.get('/%password/%')) {
				let pasd = this.$cookie.get('/%password/%');
				let ispassade = this.validate(pasd);
				if (ispassade && to.name != '引导页' && to.name != '学生端个人信息' && to.name != '登录' && to.name != '注册' && to.name != '忘记密码') {
				}
			} else if (
				to.name != '学生端个人信息' &&
				to.name != '引导页' &&
				to.name != '登录' &&
				to.name != '注册' &&
				to.name != '忘记密码' &&
				to.name != '数据分析' &&
				to.name != '学院数据分析'
			) {
				// this.$alert('您的密码过于简单,请及时切换密码!', '密码简单', {
				// 	confirmButtonText: '确定',
				// 	callback: action => {
				// 		this.$router.push('/usercenter/usermessage?passags=1');
				// 	}
				// });
			}
		});

		this.$router.beforeEach((to, from, next) => {
			this.$insProgress.start();
			if (AppOptions.appDarkMode) {
				this.handleSetDarkMode(true);
			}
			if (AppOptions.appTheme) {
				this.handleSetTheme(AppOptions.appTheme);
			}

			// console.log(to, from, "路由")
			const LOGIN_PAGE_NAME = '登录';
			const token = localStorage.getItem('token');
			var uiguid = localStorage.getItem('uiguid');
			next();
			if (!token && to.name !== LOGIN_PAGE_NAME) {
				// 未登录且要跳转的页面不是登录页
				// debugger
				// console.log(to.name,"跳转的页面")
				// console.log(to.name,"这里进来了222")
				if (
					to.name == '引导页' ||
					to.name == '注册' ||
					to.name == '找回密码' ||
					to.name == '前台' ||
					to.name == '云首页' ||
					to.name == '测试' ||
					to.name == '云课程' ||
					to.name == '资源库' ||
					to.name == '试题库'
				) {
					// console.log(to.name,"这里进来了111",to.name=='引导页')
					next();
				} else {
					// console.log(to.name,"这里进来了222")
					// 未登录且要跳转的页面不是登录页也不是公开页
					next({
						name: LOGIN_PAGE_NAME // 跳转到登录页
					});
					// console.log(to.name, '这里进来了222');
				}
			} else if (token) {
				// console.log("这里进来了333")
				// 已登录跳转的不是登录页
				if (uiguid) {
					next();
					// console.log("登录有值")
				} else {
					// 已登录跳转的是登录、注册、忘记密码公开页
					if (to.name != '引导页' || to.name === LOGIN_PAGE_NAME || to.name === '找回密码' || to.name === '注册') {
						next();
					}
				}
				// console.log(to.name, '这里进来了333',token);
			}
		});
		this.$router.afterEach(() => {
			this.$insProgress.finish();
			AppOptions.appSidebarMobileToggled = false;
		});
	}
};
</script>
